import { useTranslation } from "react-i18next";
import { Stack, StackProps } from "@mui/material";
import logo from "assets/images/AccumulusTech_Logo_Evergreen-Stacked.svg";

const Logo = (props: StackProps) => {
  const { t } = useTranslation("common");

  return (
    <Stack
      {...props}
      sx={{
        justifyContent: "center",
        mt: 6,
      }}
    >
      <img
        src={logo}
        alt={t("accumulusTechnologies")}
        width="144px"
        height="67px"
      />
    </Stack>
  );
};

export default Logo;
